export const LEGAL_PAGES = {
    "aviso-legal": {
        title: "Aviso Legal",
        updated: "Última actualización: octubre de 2026",
        sections: [
            {
                heading: "1. Titular del sitio web",
                paragraphs: [
                    "En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de que el titular de este sitio web es Keypoteca Digital S.L.U. (en adelante, «Keypoteca»), sociedad de intermediación y asesoramiento hipotecario, fundada y dirigida por Santiago Ferrer, intermediario de crédito inmobiliario certificado.",
                    "NIF: B22911184.",
                    "Domicilio social: C/ Zurbano 83, 8 izda, 28003, Madrid (España).",
                    "Teléfono de contacto: +34 622 344 472.",
                    "Correo electrónico: hola@keypoteca.es.",
                ],
            },
            {
                heading: "2. Objeto",
                paragraphs: [
                    "Este sitio web tiene por objeto informar sobre los servicios de asesoramiento e intermediación hipotecaria ofrecidos por Keypoteca, así como facilitar un canal de contacto y un simulador orientativo de condiciones hipotecarias.",
                    "El acceso y uso del sitio web implica la aceptación de las presentes condiciones. Si no estás de acuerdo con ellas, por favor abstente de utilizar este sitio.",
                ],
            },
            {
                heading: "3. Condiciones de uso",
                paragraphs: [
                    "El usuario se compromete a hacer un uso lícito, diligente y leal de los contenidos del sitio web, y a no utilizarlo para fines contrarios a la ley, la moral o el orden público.",
                    "Los resultados del simulador hipotecario son meramente orientativos y no constituyen una oferta vinculante ni una propuesta contractual. Las condiciones finales de cualquier operación dependen del estudio y aprobación por parte de las entidades financieras.",
                ],
            },
            {
                heading: "4. Propiedad intelectual e industrial",
                paragraphs: [
                    "Todos los contenidos del sitio web (textos, logotipos, marca «Keypoteca», imágenes, diseño y código) son titularidad de Keypoteca o de sus licenciantes, y están protegidos por la normativa de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución o transformación sin autorización expresa.",
                ],
            },
            {
                heading: "5. Responsabilidad",
                paragraphs: [
                    "Keypoteca no se hace responsable de los daños o perjuicios que pudieran derivarse de interferencias, omisiones, interrupciones o desconexiones del servicio, ni del mal uso que el usuario haga de los contenidos.",
                    "La información publicada sobre condiciones de mercado, tipos de interés o impuestos tiene carácter meramente informativo y puede variar con el tiempo.",
                ],
            },
            {
                heading: "6. Enlaces a terceros",
                paragraphs: [
                    "Este sitio puede contener enlaces a sitios web de terceros (por ejemplo, servicios de mensajería). Keypoteca no se responsabiliza del contenido ni de las políticas de dichos sitios.",
                ],
            },
            {
                heading: "7. Legislación aplicable y jurisdicción",
                paragraphs: [
                    "Las presentes condiciones se rigen por la legislación española. Para cualquier controversia que pudiera derivarse del acceso o uso de este sitio web, las partes se someten a los Juzgados y Tribunales de Madrid capital, salvo que la normativa de protección de consumidores establezca otro fuero.",
                ],
            },
        ],
    },
    privacidad: {
        title: "Política de Privacidad",
        updated: "Última actualización: octubre de 2026",
        sections: [
            {
                heading: "1. Responsable del tratamiento",
                paragraphs: [
                    "Responsable: Keypoteca Digital S.L.U., con NIF B22911184 (servicio de intermediación hipotecaria dirigido por Santiago Ferrer).",
                    "Domicilio: C/ Zurbano 83, 8 izda, 28003, Madrid (España).",
                    "Contacto: hola@keypoteca.es · +34 622 344 472.",
                ],
            },
            {
                heading: "2. Datos personales que recogemos",
                paragraphs: [
                    "A través de los formularios del sitio web recogemos los siguientes datos:",
                ],
                list: [
                    "Nombre y apellidos.",
                    "Dirección de correo electrónico.",
                    "Número de teléfono.",
                    "Información sobre tu proyecto hipotecario: importe estimado, tipo de hipoteca de interés y mensaje libre.",
                    "Los parámetros de la simulación hipotecaria que decidas adjuntar (precio, ahorros, plazo, tipo de interés y comunidad autónoma).",
                ],
            },
            {
                heading: "3. Finalidad del tratamiento",
                list: [
                    "Gestionar tu solicitud de estudio hipotecario y contactar contigo para prestarte el servicio de asesoramiento.",
                    "Estudiar la viabilidad de tu operación y, en su caso, trasladar tu solicitud a las entidades financieras con las que colaboramos para la obtención de ofertas.",
                    "Atender tus consultas y comunicaciones.",
                    "Cumplir las obligaciones legales que resulten de aplicación.",
                ],
            },
            {
                heading: "4. Base jurídica",
                paragraphs: [
                    "El tratamiento se basa en tu consentimiento (art. 6.1.a RGPD), prestado al enviar el formulario, y en la aplicación de medidas precontractuales a petición tuya (art. 6.1.b RGPD) para la preparación del estudio hipotecario.",
                ],
            },
            {
                heading: "5. Destinatarios de los datos",
                paragraphs: [
                    "Tus datos podrán ser comunicados a entidades financieras y sociedades de tasación colaboradoras, exclusivamente para estudiar y negociar tu hipoteca. No se ceden datos a terceros con fines publicitarios.",
                    "Utilizamos proveedores de servicios tecnológicos (alojamiento web, correo electrónico y analítica) que actúan como encargados del tratamiento bajo contrato y garantías adecuadas.",
                ],
            },
            {
                heading: "6. Plazo de conservación",
                paragraphs: [
                    "Los datos se conservarán mientras dure la relación derivada de tu solicitud y, una vez finalizada, durante los plazos legalmente exigibles. Si no se inicia ninguna relación, los datos de contacto se eliminarán transcurrido un plazo razonable desde tu solicitud.",
                ],
            },
            {
                heading: "7. Tus derechos",
                paragraphs: [
                    "Puedes ejercer en cualquier momento tus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad escribiendo a hola@keypoteca.es, indicando el derecho que deseas ejercer y adjuntando un documento que acredite tu identidad.",
                    "Si consideras que el tratamiento no se ajusta a la normativa, puedes presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).",
                ],
            },
            {
                heading: "8. Medidas de seguridad",
                paragraphs: [
                    "Keypoteca aplica medidas técnicas y organizativas apropiadas para proteger tus datos personales frente a accesos no autorizados, pérdida o alteración, incluyendo comunicaciones cifradas y acceso restringido a la información.",
                ],
            },
            {
                heading: "9. Menores de edad",
                paragraphs: [
                    "Los servicios de este sitio web están dirigidos a personas mayores de 18 años. No recogemos deliberadamente datos de menores.",
                ],
            },
        ],
    },
    cookies: {
        title: "Política de Cookies",
        updated: "Última actualización: octubre de 2026",
        sections: [
            {
                heading: "1. ¿Qué son las cookies?",
                paragraphs: [
                    "Las cookies son pequeños archivos de texto que los sitios web almacenan en tu dispositivo para funcionar correctamente, recordar preferencias o recopilar información estadística de uso.",
                ],
            },
            {
                heading: "2. Cookies que utiliza este sitio",
                list: [
                    "Cookies técnicas (necesarias): imprescindibles para el funcionamiento del sitio y la seguridad de las sesiones. No requieren consentimiento.",
                    "Cookies de preferencias: recuerdan ajustes como el estado de tu sesión en el panel de administración.",
                    "Cookies de analítica (PostHog): nos permiten conocer de forma agregada cómo se utiliza la web (páginas visitadas, interacciones) para mejorarla. Los datos se tratan de forma pseudonimizada.",
                ],
            },
            {
                heading: "3. Cookies de terceros",
                paragraphs: [
                    "Algunos servicios integrados (por ejemplo, el enlace de WhatsApp o las herramientas de analítica) pueden instalar sus propias cookies cuando interactúas con ellos. Te recomendamos consultar las políticas de privacidad de dichos terceros.",
                ],
            },
            {
                heading: "4. Cómo desactivar las cookies",
                paragraphs: [
                    "Puedes permitir, bloquear o eliminar las cookies desde la configuración de tu navegador:",
                ],
                list: [
                    "Chrome: Configuración → Privacidad y seguridad → Cookies y otros datos de sitios.",
                    "Safari: Preferencias → Privacidad.",
                    "Firefox: Ajustes → Privacidad y seguridad → Cookies y datos del sitio.",
                    "Edge: Configuración → Cookies y permisos del sitio.",
                ],
                closing: "Ten en cuenta que desactivar las cookies técnicas puede afectar al funcionamiento de algunas partes del sitio.",
            },
            {
                heading: "5. Actualización de esta política",
                paragraphs: [
                    "Esta política puede actualizarse para adaptarse a cambios normativos o técnicos. La fecha de la última revisión figura al inicio del documento.",
                ],
            },
        ],
    },
};
